export default "__VITE_ASSET__BgTPD1OB__"